import cn from 'classnames';
import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { isRuCluster } from '@/shared/lib';
import { Accordion, Modal } from '@/shared/ui';

import { ModalID, modalModel } from '@/entities/modal';

import styles from './AboutLabelingModal.module.scss';
import { LabelingContent } from './LabelingContent/LabelingContent';
import { LabelingHeader } from './LabelingHeader/LabelingHeader';

type AboutLabelingModalProps = {
  className?: string;
};

export const AboutLabelingModal: FC<AboutLabelingModalProps> = (props) => {
  const { className } = props;

  const dispatch = useAppDispatch();

  const [country, setCountry] = useState<string>(isRuCluster() ? 'Россия' : '');

  const { visible } = useAppSelector(
    modalModel.selectors.selectAboutLabelingModal,
  );

  const handleChange = (newValue: string | string[]) => {
    if (typeof newValue === 'string') {
      setCountry(newValue);
    }
  };

  const handleClose = () => {
    dispatch(modalModel.actions.closeModal(ModalID.AboutLabelingModal));
  };

  return (
    <Modal
      data-component="about-labeling-modal"
      isOpen={visible}
      onCancel={handleClose}
      className={cn(styles.container, className)}
      title={
        isRuCluster() ? (
          'О Diagnocat'
        ) : (
          <FormattedMessage
            id="labeling.aboutDiagnocat"
            defaultMessage="About Diagnocat"
          />
        )
      }
      hideFooter
    >
      <Accordion.Root type="single" defaultValue="labeling">
        <Accordion.Item value="labeling" className={styles.item}>
          <Accordion.Header>
            <LabelingHeader onChange={handleChange} country={country} />
          </Accordion.Header>

          {country && (
            <Accordion.Content>
              <LabelingContent country={country} />
            </Accordion.Content>
          )}
        </Accordion.Item>
      </Accordion.Root>
    </Modal>
  );
};
